import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ApiGeolocationService {
    url = 'https://api.ipgeolocation.io/ipgeo?apiKey=717b2a54e6ad4ad7b7bd272793560448';
    constructor(private http: HttpClient) { }
    getGeolocation() {
        return this.http.get(this.url);
    }
}
